// employees/EmployeeContext.js
import React, { createContext, useContext, useState, useMemo, useEffect, useCallback } from 'react';
import {itemRender, handlePageChange, defaultPagination, pageSizeOptions} from "utils/table";
import {getAllAssetsApi, getAssetCategory} from "api/services/assets"
import { useSearchParams } from 'react-router-dom';
import useAssetFilter from "./../hooks/filterHook"
import {  useNavigate } from "react-router-dom";
import {format} from "date-fns"

import { filterHandler } from 'utils/common';
import { useMediaQuery } from "react-responsive";

									  

// Create the Asset context
const AssetContext = createContext();

// Custom hook for accessing Asset context easily
export const useAssets = () => {
  return useContext(AssetContext); 
};

// AssetProvider component to wrap around components needing access to asset data
export const AssetsProvider = ({ children }) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

    const navigate = useNavigate()

  
  const [loading, setLoading] = useState(false);
  const [selectedPage, setSelectedPage] = useState(0);
												   

  const [assetModal,setAssetModal]= useState(false);
  
  const [assetData, setAssetData] = useState([]);
  const [assetCategory, setAssetCategory] = useState([]);

  const [view, setView] = useState(isMobile? "grid":"list");
  const [showFilterDrawer, setShowFilterDrawer] = useState(false)
  const [pageSettings , setPageSettings] = useState({
    ...defaultPagination,
    page: searchParams.get("page") || 1,
    pageSize: searchParams.get("size") || 50,
    sortType: searchParams.get("sort_type") || "",
    sortBy: searchParams.get("sort_byb") || "",

})
const { handleFilterChange,
    filters,
    handleInputChange, filterLoading, setFilterLoading, handleDateChange, handleClearAll,
    isFilterDirty, setIsFilterDirty} = useAssetFilter(pageSettings , setPageSettings);

const getFilterParams = useCallback(()=>{
  let filter_params = filterHandler(filters)
    return filter_params
        
})

const setAssetParams = (pageData) => {
    let filter_params = getFilterParams()
    let params = {
        size: pageData?.pageSize,
        page: pageData?.page,
        sort_by: pageData?.sortBy || "",
        sort_type: pageData?.sortType || "",
        ...filter_params
    }
    setSearchParams(params)
}
// handleInputChange = (value, key)=>{
//     setPageSettings({
//         ...pageSettings,
//         page: 1,
//         filters
//       })
//       handleSearchInput(value, key))
// }


    const getAssetList = () => {
        setLoading(true)
        setFilterLoading(true)

        // let _filters = [...filters].filter(item=> item.value)
        // const filter_params = _filters.reduce((acc, item) => {
        //     acc[item.key] = item.value;
        //     return acc;
        //   }, {});
        let filter_params = getFilterParams()

        if(filter_params?.employment_date_after){
            filter_params.employment_date_after = format(new Date(filter_params.employment_date_after), "yyyy-MM-dd")
        }
        if(filter_params?.employment_date_before){
            filter_params.employment_date_before = format(new Date(filter_params.employment_date_before), "yyyy-MM-dd")
        }

        let ordering =  ""
        if(pageSettings?.sortType === "ascend"){
            ordering = "-" + pageSettings?.sortBy;
        } else {
            ordering = pageSettings?.sortBy;
        }

          
        getAllAssetsApi({
          ordering,
          page_size: pageSettings?.pageSize,
          page: pageSettings?.page,
          ...filter_params
    
        }).then(response=>{
          console.log(response.data.results, "resultsss---->>>")
          if(view=="grid" && pageSettings?.page!==1){
            setAssetData([...assetData,...response.data.results]);

          }else{
            setAssetData(response.data.results);

          }
          
          setPageSettings((prev) => ({
            ...prev,
            total: response.data.count
          }))
    
          setLoading(false)
          setFilterLoading(false)
        }).catch(e=>{
          setLoading(false)
        })
    }
  useEffect(()=>{

    getAssetList()

  },[pageSettings?.page, pageSettings?.pageSize, pageSettings?.sortBy, pageSettings?.sortType, pageSettings?.filters])

  useEffect(()=>{
    setAssetParams(pageSettings)
  },[pageSettings])

  useEffect(()=>{
    getAssetCategory().then(response=>{
      setAssetCategory(response.data?.results)
    })
  },[])

  const handleApplyFilter = () => {
    // setFilterLoading(true)
    setShowFilterDrawer(false)
    setIsFilterDirty(false)
    setPageSettings({
        ...pageSettings,
        page: 1,
        filters
      })
    // getEmployeeList()


  }


  const handleGridChange = (page, size) =>{
    setPageSettings({
      ...pageSettings,
      pageSize: size,
      page,
    })
					 
			 
			 
	  
    // setSearchParams({
    //     size,
    //     page,
    // })
  }


  const handleChange = (pagination, filters, sorter) => {
    let pageData = handlePageChange(pagination, filters, sorter, pageSettings)
    console.log(pageData)
    // setSearchParams({
    //     size: pageData?.pageSize,
    //     page: pageData?.page,
    //     sort_by: pageData?.sortBy || "",
    //     sort_type: pageData?.sortType || ""
    // })
    setPageSettings(pageData)
  };

							 
			
																														   

										 
														 
														  
								   
				   
			   
						
		
  

  const handleFilterDrawer = () => {
    console.log("JJJJJJJ")
    setShowFilterDrawer(!showFilterDrawer)
    setFilterLoading(false)
  }


  const handleAssetDetailPage = (id, index) => {		
   // console.log(id, "----ASSET ID----")	
   // return					  
    navigate(`/assets/${id}`)
    setSelectedPage(index)
  }



  // Value to be provided to context consumers
  // Memoize the context value to avoid unnecessary re-renders
  const value = useMemo(() => ({
    assetData, setAssetData,
    loading, setLoading,
   
    view, setView,
    pageSettings , setPageSettings,
    showFilterDrawer, setShowFilterDrawer,

    filterLoading, setFilterLoading,
    selectedPage, setSelectedPage,

    handleGridChange,
    handleChange,

    handleFilterDrawer,

    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    handleAssetDetailPage,
    handleDateChange,
    handleClearAll,
    setLoading,
    assetModal,setAssetModal,
    assetCategory,
    getAssetList,
    isFilterDirty

  }), [assetData , view, loading, pageSettings, showFilterDrawer, filters, filterLoading, selectedPage, assetModal, assetCategory, isFilterDirty]);

  return (
    <AssetContext.Provider value={value}>
      {children}
    </AssetContext.Provider>
  );
};